import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { CommonService } from "../../_services/common.service";
import { HttpErrorResponse } from "@angular/common/http";
import { FlashMessagesService } from "angular2-flash-messages";
import { ConfirmationDialogComponent } from "../../shared/confirmation-dialog/confirmation-dialog.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ClientImportComponent } from "../client-import/client-import.component";

@Component({
  selector: "app-clients",
  templateUrl: "./clients.component.html",
  styleUrls: ["./clients.component.css"]
})
export class ClientsComponent implements OnInit, OnDestroy {
  filterByDateForm: FormGroup;
  public clientLists: Array<any> = [];
  public loading = false;
  public showForm = false;
  public showClient = false;
  public total = 0;
  public pagesToShow = 10;
  public page = 1;
  public limit = 50;
  public startDate: string = "";
  public endDate: string = "";
  public taxExempt: string = "";
  public exportCsv = false;
  public clearFilterButtonEnabled = false;
  public clientOptions: any = {};
  public search: string = "";
  public sortColumnName = "created";
  public sortDirection = "desc";
  public filterClientText: string;
  public page_header: string = "Clients Management";
  public editClientData: any = {};
  public idform: any;
  navigationSubscription;
  public isPublicQuoteCreation = false;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private CommonService: CommonService,
    private router: Router,
    private _flashMessagesService: FlashMessagesService,
    public dialog: MatDialog
  ) {
    this.filterByDateForm = this.fb.group({
      start_date: [null],
      end_date: [null],
      tax_exempt: [null]
    })
    // override the route reuse strategy
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.navigationSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
  }

  ngOnInit() {
    if (this.route.snapshot.params["id"] || this.route.snapshot.params["clientID"]) {
      let clientID = (this.route.snapshot.params["id"]) ? this.route.snapshot.params["id"] : this.route.snapshot.params["clientID"];
      this.formEdit(clientID);
    }
    else {
      this.route.params.subscribe(params => {
        this.toggleForm(true);
      });
    }

  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  openDialog(id: number): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "250px",
      data: {
        name: "Admin",
        message: "Are you sure you want to delete this Client",
        manageData: { client_id: id }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.client_id) {
        this.deleteClient(result.client_id);
      }
    });
  }

  filterByDate = function (postData) {
    if (this.filterByDateForm.valid) {
      this.startDate = postData.start_date;
      this.endDate = postData.end_date;
      this.taxExempt = postData.tax_exempt;
      this.clearFilterButtonEnabled = true;
      this.getClientList();
    } else {
      this.validateAllFormFields(this.filterByDateForm);
    }
  };

  clearFilter() {
    this.startDate = '';
    this.endDate = '';
    this.taxExempt = '';
    this.clearFilterButtonEnabled = false;
    this.filterByDateForm.reset();
    this.getClientList();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
  isFieldValid(field: string) {
    return (
      !this.filterByDateForm.get(field).valid &&
      this.filterByDateForm.get(field).touched
    );
  }

  clientEditForm(client) {
    this.getClientDetail(client);
    this.showForm = true;
  }
  formEdit(id) {
    this.idform = id;
    this.showClient = true;
  }
  toggleForm(loading) {
    if (loading == true) {
      this.editClientData = {};
      this.getClientList();
    }
    this.showForm = !loading;

    return !this.showForm;
  }
  clientViewForm(loading) {
    this.showClient = !loading;
    this.page_header = loading == true ? "Clients Management" : "";
  }

  isEnabled(check_val) {
    return check_val == "Active" ? true : false;
  }

  getClientDetail = function (client) {
    this.clientOptions = {};
    this.CommonService.apiService(
      "GET",
      "user/" + client.user_id,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data) {
            this.editClientData = response.data;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  };

  deleteClient = function (id) {
    this.clientOptions = {};
    this.CommonService.apiService(
      "DELETE",
      "user/" + id,
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("Client deleted successfuly!", {
            cssClass: "alert-success",
            timeout: 5000
          });
          this.getClientList();
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  updateClientStatus = function (id) {
    this.clientOptions = {
      id: id
    };
    this.CommonService.apiService(
      "POST",
      "user/status",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this._flashMessagesService.show("Details updated successfully!", {
            cssClass: "alert-success",
            timeout: 5000
          });
        }
      },
      err => {
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-danger",
          timeout: 5000
        });
      }
    );
  };

  getClientList = function () {
    let headerList = ['company_name', 'first_name', 'last_name', 'email', 'phone', 'address1', 'address2', 'city', 'state', 'zip', 'total_amount_spent'];
    let fileName = 'client-list';
    this.clientOptions = {
      page: this.page,
      id: localStorage.getItem("userID")
    };
    if (this.exportCsv == false) {
      this.loading = true;
      this.clientOptions.limit = this.limit;
    }
    if (this.filterClientText) {
      this.clientOptions.search = this.filterClientText;
    }
    if (this.sortDirection) {
      this.clientOptions.orderBy = this.sortColumnName;
      this.clientOptions.direction = this.sortDirection;
    }
    if (this.startDate) {
      this.clientOptions.startDate = this.startDate;
    }
    if (this.endDate) {
      this.clientOptions.endDate = this.endDate;
    }
    if (this.taxExempt) {
      this.clientOptions.taxExempt = this.taxExempt;
    }

    this.CommonService.apiService(
      "POST",
      "users",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        this.loading = false;
        if (response.status === true) {
          if (response.data) {
            if (this.exportCsv == false) {
              this.clientLists = response.data.records;
              this.total = response.data.total;
              this.current_page = response.data.current_page;
              this.limit = response.data.limit;
            } else {
              this.exportCsv = false
              this.CommonService.downloadFile(response.data.records, headerList, fileName);
            }
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  };

  filterClient(): void {
    this.page = 1;
    this.total = 0;
    this.getClientList();
  }

  clearFilterClient(): void {
    this.filterClientText = "";
    this.page = 1;
    this.total = 0;
    this.getClientList();
  }

  goToPage(n: number): void {
    this.page = n;
    this.getClientList();
  }

  onNext(): void {
    this.page++;
    this.getClientList();
  }

  onPrev(): void {
    this.page--;
    this.getClientList();
  }

  goSort($event) {
    this.sortColumnName = $event.columnName;
    this.sortDirection = $event.sortDirection;
    this.getClientList();
  }

  exportCSV() {
    this.exportCsv = true;
    this.getClientList();
  }

  openImportClientDialog() {
    const dialogRef = this.dialog.open(ClientImportComponent, {
      width: "500px",
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-users/clients/clients.component.ts